import _extends from "@babel/runtime/helpers/extends";

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import React, { useCallback } from "react";
import PropTypes from "prop-types";
import { useNavigate } from "react-router";
import { useSelector } from "../../../store";
import BackButton from "../components/BackButton";
import * as selectors from "../state/selectors";
import useLanguage from "../../Translation/hooks/useLanguage";

const BackButtonContainer = _ref => {
  let {
    defaultBackUrl,
    onBackAction,
    ...otherProps
  } = _ref;
  console.log(defaultBackUrl, onBackAction);
  const locations = useSelector(selectors.locationsSelector);
  const {
    dir
  } = useLanguage();
  const isRtl = dir === "rtl";
  const navigate = useNavigate();
  const onClick = useCallback(() => {
    if (onBackAction) {
      onBackAction();
    } else {
      navigate(defaultBackUrl, {
        state: {
          action: "PUSH"
        }
      }); // if (locations.length > 1) {
      //   navigate(-1);
      // } else if (defaultBackUrl) {
      //   navigate(defaultBackUrl, { state: { action: "PUSH" } });
      // }
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [defaultBackUrl, navigate, locations, onBackAction]);
  return locations.length > 1 || defaultBackUrl ? /*#__PURE__*/React.createElement(BackButton, _extends({
    isRtl: isRtl
  }, otherProps, {
    onClick: onClick
  })) : null;
};

__signature__(BackButtonContainer, "useSelector{locations}\nuseLanguage{{ dir }}\nuseNavigate{navigate}\nuseCallback{onClick}", () => [useSelector, useLanguage, useNavigate]);

BackButtonContainer.displayName = "BackButtonContainer";
BackButtonContainer.propTypes = {
  defaultBackUrl: PropTypes.string,
  onBackAction: PropTypes.func
};
BackButtonContainer.defaultProps = {
  defaultBackUrl: null,
  onBackAction: null
};
const _default = BackButtonContainer;
export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(BackButtonContainer, "BackButtonContainer", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/modules/BrowserHistory/containers/BackButtonContainer.jsx");
  reactHotLoader.register(_default, "default", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/modules/BrowserHistory/containers/BackButtonContainer.jsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();